<template>
	<view class="box">
		<view class="box_title">
			<view class="banner">
				<view class="banner_left" @click="left">
					<uni-icons type="back" size="30" color="#999999"></uni-icons>
				</view>
				<view class="banner_box">
					<swiper class="swiper" circular :indicator-dots="false" :autoplay="false" :interval="2000" id="swiper" :current="current" :duration="500">
						<swiper-item v-for="(item,index) in info" :key="index">
							<view class="swiper-item">
								<image src="@/static/uni.png" mode="heightFix"></image>
							</view>
						</swiper-item>
					</swiper>
				</view>
				<view class="banner_right" @click="right">
					<uni-icons type="forward" size="30" color="#999999"></uni-icons>
				</view>
			</view>
			<view class="title">海耶斯谷（浓缩）</view>
			<view class="info">Hayes Valley (concentrated)</view>
		</view>
		<view class="box_pays">
			<view class="box_pay" style="margin: 16rpx 0;">
				<view class="box_pay_a">支付周期（3个月·共6期）</view>
				<view class="box_pay_b">2023-01-26～2023-06-26</view>
				<view class="box_pay_c">
					<view class="box_pay_c_left">
						<text>¥</text>
						<text>174</text>
						<text>.98</text>
					</view>
					<view class="box_pay_c_right">
						<text>去支付</text>
						<uni-icons type="forward" color="#999999" size="20"></uni-icons>
					</view>
				</view>
			</view>
			<view class="box_pay">
				<view class="box_pay_info">
					<view class="box_pay_info_left">
						<view class="box_pay_a">支付周期（3个月·共6期）</view>
						<view class="box_pay_b">2023-01-26～2023-06-26</view>
					</view>
					<view class="box_pay_info_right">
						<text>展开</text>
						<uni-icons type="bottom" size="20" color="#999999"></uni-icons>
					</view>
				</view>
				<view class="box_pay_x"></view>
				<view class="box_pay_data">
					<view class="label">收货信息</view>
					<view class="info">
						<image src="@/static/icon/huodong_ic_didian@2x.png" mode="widthFix"></image>
						<view class="info_right">
							<view class="info_right_top">
								<text>刘美女</text>
								<text>17839484470</text>
							</view>
							<view class="info_right_bottom">上海 上海市 青浦区 夏阳街道华科路新青浦家园144号楼101</view>
						</view>
					</view>
				</view>
				<view class="box_pay_desc">
					<view class="label">订阅详情</view>
					<view class="box_pay_desc_list">
						<view class="box_pay_desc_list_l">
							<view class="box_pay_desc_list_l_item">
								<view class="dian">
									<view class="dian_dian"></view>
								</view>
								<div class="xian_x"></div>
							</view>
							<view class="box_pay_desc_list_l_item">
								<view class="dian">
									<view class="dian_dian"></view>
								</view>
								<div class="xian_x"></div>
							</view>
							<view class="box_pay_desc_list_l_item">
								<view class="desad"></view>
								<div class="xian_x disable"></div>
							</view>
						</view>
						<view class="box_pay_desc_list_r">
							<view class="box_pay_desc_list_item">
								<view class="dian">
									<view class="dian_dian"></view>
								</view>
								<text class="qi">第一期</text>
								<view class="box_pay_desc_list_item_box">
									<view class="left">
										<view class="left_item">
											<view class="left_item_h">计划</view>
											<text>2023-03-24</text>
										</view>
										<view class="left_item">
											<view class="left_item_h h">实际</view>
											<text>2023-03-24</text>
										</view>
									</view>
									<view class="right">
										<text>已完成</text>
										<uni-icons type="forward" size="20" color="#999999"></uni-icons>
									</view>
								</view>
							</view>
							<view class="box_pay_desc_list_item">
								<text class="qi">第二期</text>
								<view class="box_pay_desc_list_item_box">
									<view class="left">
										<view class="left_item">
											<view class="left_item_h">计划</view>
											<text>2023-03-24</text>
										</view>
										<view class="left_item">
											<view class="left_item_h h">实际</view>
											<text>2023-03-24</text>
										</view>
									</view>
									<view class="right">
										<text>已发货</text>
										<uni-icons type="forward" size="20" color="#999999"></uni-icons>
									</view>
								</view>
							</view>
							<view class="box_pay_desc_list_item">
								<text class="qi">第三期</text>
								<view class="box_pay_desc_list_item_box">
									<view class="left">
										<view class="left_item">
											<view class="left_item_h">计划</view>
											<text>2023-03-24</text>
										</view>
										<view class="left_item">
											<view class="left_item_h h">实际</view>
											<text>2023-03-24</text>
										</view>
									</view>
									<view class="right">
										<text>未开始</text>
									</view>
								</view>
							</view>
						</view>
					</view>
				</view>
			</view>
		</view>
		<view class="box_zw"></view>
		<view class="shop_operate">
			<view class="shop_operate_list">
				<view class="shop_operate_list_item">
					<image src="@/static/icon/ic_kefu@2x.png" mode="widthFix"></image>
					<text>客服</text>
				</view>
				<view class="shop_operate_list_item">
					<image src="@/static/icon/ic_fenxiang@2x.png" mode="widthFix"></image>
					<text>分享</text>
				</view>
				<view class="shop_operate_list_item">
					<image src="@/static/icon/ic_pinglun@2x.png" mode="widthFix"></image>
					<text>评价</text>
				</view>
			</view>
			<view class="shop_operate_ipt">继续订阅</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				info: [{
					content: '内容 A'
				}, {
					content: '内容 B'
				}, {
					content: '内容 C'
				}],
				current: 0
			}
		},
		methods: {
			change(e) {
				this.current = e.detail.current;
			},
			left() {
				let current = this.current;
				let ncurrent = current > 0 ? current - 1 : this.info.length - 1;
				this.current = ncurrent
			},
			right() {
				let current = this.current;
				let ncurrent = current < (this.info.length - 1) ? current + 1 : 0;
				this.current = ncurrent
			}
		}
	}
</script>

<style lang="scss" scoped>
	.box {
		width: 100%;
		.box_title {
			width: 100%;
			padding: 16rpx 32rpx 46rpx 32rpx;
			box-sizing: border-box;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			background-color: #ffffff;
			.title {
				font-size: 40rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
				margin-top: 32rpx;
			}
			.info {
				font-size: 28rpx;
				font-family: PingFang SC-Regular, PingFang SC;
				font-weight: 400;
				color: #333333;
				margin-top: 12rpx;
			}
			.banner /deep/ {
				width: 100%;
				height: 274rpx;
				margin-top: 38rpx;
				display: flex;
				align-items: center;
				.banner_left {
					flex: 1;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
				}
				.banner_right {
					flex: 1;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
				}
				.banner_box {
					width: 314rpx;
					height: 100%;
					.swiper {
						width: 100%;
						height: 100%;
						.swiper-item {
							width: 100%;
							height: 100%;
							display: flex;
							align-items: center;
							justify-content: center;
							image {
								width: 100%;
								height: 100%;
							}
						}
					}
				}
			}
		}
		.box_zw {
			width: 100%;
			height: calc(96rpx + env(safe-area-inset-bottom));
		}
		.shop_operate {
			width: 100%;
			padding: 16rpx 32rpx calc(env(safe-area-inset-bottom) + 16rpx) 0;
			box-sizing: border-box;
			background-color: #FFFFFF;
			border: 2rpx solid #F4F5F4;
			position: fixed;
			bottom: 0;
			left: 0;
			display: flex;
			align-items: center;
			justify-content: space-between;
			z-index: 9;
			.shop_operate_ipt {
				width: 440rpx;
				height: 64rpx;
				line-height: 64rpx;
				text-align: center;
				background: linear-gradient(90deg, #D95A5A 0%, #D20A0A 100%);
				border-radius: 32rpx 32rpx 32rpx 32rpx;
				box-sizing: border-box;
				font-size: 32rpx;
				font-family: PingFang SC-Regular, PingFang SC;
				font-weight: 400;
				color: #FFFFFF;
				margin-left: 20rpx;
			}
			.shop_operate_list {
				flex: 1;
				display: flex;
				align-items: center;
				.shop_operate_list_item {
					flex: 1;
					display: flex;
					align-items: center;
					flex-direction: column;
					image {
						width: 30rpx !important;
						height: 30rpx !important;
						margin-bottom: 8rpx;
					}
					text {
						font-size: 16rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #999999;
					}
				}
			}
		}
		.box_pays {
			display: flex;
			flex-direction: column;
			.box_pay {
				width: 100%;
				// margin-top: 16rpx;
				padding: 26rpx 32rpx;
				box-sizing: border-box;
				background-color: #ffffff;
				border-bottom: 2rpx solid #F4F5F4;
				&:last-child {
					border: none !important;
				}
				.box_pay_info {
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: space-between;
					.box_pay_info_left {
						display: flex;
						flex-direction: column;
						.box_pay_a {
							font-size: 32rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #333333;
						}
						.box_pay_b {
							font-size: 28rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #333333;
							margin-top: 24rpx;
						}
					}
					.box_pay_info_right {
						display: flex;
						align-items: center;
						text {
							font-size: 28rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #333333; 
							margin-right: 8rpx;
						}
					}
				}
				.box_pay_x {
					width: 100%;
					height: 0rpx;
					margin: 28rpx 0;
					border: 2rpx solid #F4F5F4;
				}
				.box_pay_data {
					width: 100%;
					.label {
						font-size: 32rpx;
						font-family: PingFang SC-Semibold, PingFang SC;
						font-weight: 600;
						color: #333333;
					}
					.info {
						width: 100%;
						display: flex;
						align-items: center;
						margin-top: 28rpx;
						image {
							width: 24rpx;
							height: 30rpx;
							flex-shrink: 0;
							margin-right: 20rpx;
						}
						.info_right {
							flex: 1;
							display: flex;
							flex-direction: column;
							.info_right_top {
								display: flex;
								align-items: center;
								margin-bottom: 18rpx;
								text {
									&:first-child {
										font-size: 28rpx;
										font-family: PingFang SC-Medium, PingFang SC;
										font-weight: 500;
										color: #333333;
										margin-right: 12rpx;
									}
									&:last-child {
										font-size: 24rpx;
										font-family: PingFang SC-Medium, PingFang SC;
										font-weight: 500;
										color: #999999;
									}
								}
							}
							.info_right_bottom {
								font-size: 24rpx;
								font-family: PingFang SC-Regular, PingFang SC;
								font-weight: 400;
								color: #333333; 
								margin: 0 !important;
							}
						}
					}
				}
				.box_pay_desc {
					margin-top: 44rpx;
					.label {
						font-size: 32rpx;
						font-family: PingFang SC-Semibold, PingFang SC;
						font-weight: 600;
						color: #333333; 
						margin-bottom: 28rpx;
					}
					.box_pay_desc_list {
						display: flex;
						align-items: flex-start;
						justify-content: space-between;
						.box_pay_desc_list_l {
							width: 40rpx;
							margin-right: 20rpx;
							flex-shrink: 0;
							display: flex;
							flex-direction: column;
							.box_pay_desc_list_l_item {
								width: 100%;
								height: 206rpx;
								margin-top: 11rpx;
								position: relative;
								.disable {
									background-color: #D9D9D9 !important;
								}
								.xian_x {
									width: 2rpx;
									height: 220rpx;
									background-color: #D20A0A;
									position: absolute;
									top: 5rpx;
									left: 9rpx;
									z-index: 1;
								}
								.desad {
									width: 12rpx;
									height: 12rpx;
									border-radius: 50%;
									background-color: #D9D9D9;
									position: relative;
									z-index: 6;
									margin-left: 2rpx;
								}
								.dian {
									position: relative;
									z-index: 6;
									width: 20rpx;
									height: 20rpx;
									background: rgba(210,10,10,0.4);
									border-radius: 50%;
									display: flex;
									align-items: center;
									justify-content: center;
									.dian_dian {
										width: 12rpx;
										height: 12rpx;
										background: #D20A0A;
										border-radius: 50%;
									}
								}
							}
						}
						.box_pay_desc_list_r {
							flex: 1;
							display: flex;
							align-items: center;
							flex-direction: column;
							.box_pay_desc_list_item {
								width: 100%;
								display: flex;
								flex-direction: column;
								&:first-child {
									.qi {
										margin-top: 0 !important;
									}
								}
								.qi {
									font-size: 28rpx;
									font-family: PingFang SC-Medium, PingFang SC;
									font-weight: 500;
									color: #333333;
									margin-bottom: 32rpx;
									margin-top: 40rpx;
								}
								.box_pay_desc_list_item_box {
									display: flex;
									align-items: center;
									.left {
										flex: 1;
										display: flex;
										flex-direction: column;
										.left_item {
											margin-bottom: 32rpx;
											display: flex;
											align-items: center;
											&:last-child {
												margin-bottom: 0 !important;
											}
											.h {
												background: rgba(210,10,10,0.08) !important;
												color: #D20A0A !important;
											}
											.left_item_h {
												width: 80rpx;
												height: 40rpx;
												line-height: 40rpx;
												text-align: center;
												background: #FDF9DC;
												border-radius: 20rpx;
												font-size: 24rpx;
												font-family: PingFang SC-Medium, PingFang SC;
												font-weight: 500;
												color: #F6AF12;
												margin-right: 12rpx;
											}
											text {
												font-size: 28rpx;
												font-family: PingFang SC-Medium, PingFang SC;
												font-weight: 500;
												color: #999999;
											}
										}
									}
									.right {
										display: flex;
										align-items: center;
										text {
											font-size: 28rpx;
											font-family: PingFang SC-Medium, PingFang SC;
											font-weight: 500;
											color: #333333;
											margin-right: 8rpx;
										}
									}
								}
							}
						}
					}
				}
				.box_pay_c {
					margin-top: 40rpx;
					display: flex;
					align-items: center;
					justify-content: space-between;
					.box_pay_c_left {
						display: flex;
						align-items: center;
						text {
							&:nth-child(1) {
								font-size: 28rpx;
								font-family: PingFang SC-Semibold, PingFang SC;
								font-weight: 600;
								color: #D20A0A;
								margin-top: 12rpx;
							}
							&:nth-child(2) {
								font-size: 40rpx;
								font-family: PingFang SC-Semibold, PingFang SC;
								font-weight: 600;
								color: #D20A0A;
							}
							&:nth-child(3) {
								font-size: 28rpx;
								font-family: PingFang SC-Semibold, PingFang SC;
								font-weight: 600;
								color: #D20A0A;
								margin-top: 12rpx;
							}
						}
					}
					.box_pay_c_right {
						display: flex;
						align-items: center;
						text {
							font-size: 28rpx;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #D20A0A; 
							margin-right: 8rpx; 
						}
					}
				}
			}
		}
	}
</style>